import { ERequestStatus } from 'src/api/enumRequest';
import { ETransactionStatus, ECryptoAddressTagType } from 'src/type';

export enum EPricingMode {
  LongLivedQuote = 'Long Lived Quote',
  ConvertOnArrival = 'Convert On Arrival',
}

export enum EInvoice {
  Invoice = 'Invoice',
  OpenDeposit = 'Open Deposit',
}

export interface IPaymentState {
  getPayment: {
    payment: IPaymentItem | null;
    status: ERequestStatus;
    error: string;
  };

  widgetLanguages: IWidgetLanguage[];

  widgetSettings: IWidgetSettings;

  getPaymentTransactions: IPaymentTransactionItem[];

  createPaymentAddress: {
    address: string;
    address_currency_id: string;
    address_id: string;
    tag_type?: ECryptoAddressTagType;
    tag_value?: string;
    status: ERequestStatus;
    error: string;
  };
}

export interface IPaymentItem {
  client_status: string;
  created: string;
  currency_id: string;
  currency_network: string;
  currency_settings: IPaymentCurrencySetting[];
  currency_type: string;
  expiration: number;
  fees_values: IFeesValues[];
  id: string;
  is_fees_in_price_quote: boolean;
  merchant_fee_amount: number;
  merchant_order_description: string;
  parent_merchant_fee_amount: number;
  passthrough_fees: boolean;
  pricing_mode: EPricingMode;
  target_currency_amount_left: number | null;
  target_currency_amount_paid: number | null;
  target_currency_amount_required: number | null;
  total_fee_amount: number;
  type: EInvoice;
  updated: string;
}

export interface IWidgetLanguage {
  id: string;
  name: string;
}

export interface IWidgetSettings {
  merchantName: string;
  redirectUrl: string;
}

export interface IPaymentCurrencySetting {
  enabled: boolean;
  currency_id: string;
  network: string;
  is_converted: boolean;
  required_confirmations: number;
  is_preferred: boolean;
  type: string;
}

export interface IFeesValues {
  currency_id: string;
  deposit_fee: number;
  deposit_flat_fee: number;
  updated_at: string;
}

export interface IPaymentTransactionItem {
  source_currency_id: string;
  source_currency_network: string;
  status: ETransactionStatus;
  source_amount_received: number;
  estimated_target_amount: number;
  confirmations: number;
  crypto_transaction_id: string;
  sub_merchant_fee_amount: number;
}
